var $ = require("jquery");
import gsap from "gsap";
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* ====================== SERVICES SLIDER ======================  */
var servicesSlider = new Swiper('.services-slider .swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      430: {
        slidesPerView: 1.1,
      },
      768: {
          slidesPerView: 2,
      },
      1024: {
          slidesPerView: 2.93,
          spaceBetween: 30,
      },
    },
});

/* ====================== INDUSTRIES SLIDER ======================  */
document.querySelectorAll('.industries-slider').forEach(function (block) {
  var swiperEl = block.querySelector('.industries-slider__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  var industriesSwiper = new Swiper(swiperEl, {
    // loop: true,
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 1000,
    breakpoints: {
      480: { slidesPerView: 1.5 },
      768: { slidesPerView: 2.5},
      1024: { slidesPerView: 3.5},
      1200: { slidesPerView: 4},
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function (swiper) {
        if (progressFill) progressFill.style.width = (swiper.progress * 100) + '%';
      },
      progress: function (swiper, progress) {
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
      },
    },
  });
});

/* ====================== PROCESS STEPS ======================  */
document.querySelectorAll('.process-steps').forEach(function (block) {
  var swiperEl = block.querySelector('.process-steps__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  var tabsEl = block.querySelector('.process-steps__tabs');
  var tabs = block.querySelectorAll('.process-steps__tab');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var mobileTabsMq = window.matchMedia('(max-width: 767px)');

  function syncProcessStepsTab(index) {
    setActiveTab(tabs, index);
    scrollProcessStepsTabToStart(tabsEl, tabs[index], mobileTabsMq);
  }

  var processStepsSwiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    breakpoints: {
      768: {
        spaceBetween: 110,
      },
    },
    speed: 500,
    allowTouchMove: true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function (swiper) {
        syncProcessStepsTab(swiper.activeIndex);
      },
      slideChange: function (swiper) {
        syncProcessStepsTab(swiper.activeIndex);
      },
    },
  });

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () {
      processStepsSwiper.slideTo(index);
    });
  });
});

function setActiveTab(tabs, index) {
  if (!tabs || !tabs.length) return;
  tabs.forEach(function (t, i) {
    t.classList.toggle('process-steps__tab--active', i === index);
    t.setAttribute('aria-selected', i === index ? 'true' : 'false');
  });
}

function scrollProcessStepsTabToStart(tabsEl, tabEl, mq) {
  if (!tabsEl || !tabEl || !mq || !mq.matches) return;
  var scrollLeft =
    tabEl.getBoundingClientRect().left -
    tabsEl.getBoundingClientRect().left +
    tabsEl.scrollLeft;
  tabsEl.scrollTo({
    left: scrollLeft,
    behavior: 'smooth',
  });
}

/* ====================== BLOG SLIDER ======================  */
document.querySelectorAll('.blog-slider').forEach(function (block) {
  var swiperEl = block.querySelector('.blog-slider__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  new Swiper(swiperEl, {
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 600,
    breakpoints: {
      480: { slidesPerView: 1.5 },
      768: { slidesPerView: 2, spaceBetween: 24 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1200: { slidesPerView: 3, spaceBetween: 24 },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function (swiper) {
        if (progressFill) progressFill.style.width = (swiper.progress * 100) + '%';
      },
      progress: function (swiper, progress) {
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
      },
    },
  });
});

/* ====================== GALLERY SLIDER ======================  */
document.querySelectorAll('.gallery-slider').forEach(function (block) {
  var swiperEl = block.querySelector('.gallery-slider__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  new Swiper(swiperEl, {
    slidesPerView: 1.15,
    spaceBetween: 16,
    speed: 600,
    breakpoints: {
      480: { slidesPerView: 1.1, spaceBetween: 20 },
      768: { slidesPerView: 1.1, spaceBetween: 24 },
      1024: { slidesPerView: 1.5, spaceBetween: 24 },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function (swiper) {
        if (progressFill) progressFill.style.width = (swiper.progress * 100) + '%';
      },
      progress: function (swiper, progress) {
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
      },
    },
  });
});

/* ====================== GOOGLE REVIEWS ======================  */
document.querySelectorAll('.google-reviews').forEach(function (block) {
  var swiperEl = block.querySelector('.google-reviews__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  // centerInsufficientSlides is ignored when loop is enabled; skip loop for 1–2 reviews
  // so a short row is centred instead of left-aligned.
  var reviewCount = wrapper.children.length;
  var useLoop = reviewCount > 2;

  new Swiper(swiperEl, {
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 600,
    loop: useLoop,
    centerInsufficientSlides: true,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
    breakpoints: {
      480: { slidesPerView: 1.5 },
      768: { slidesPerView: 2, spaceBetween: 24 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
    },
  });
});

/* ====================== CASE STUDY INTRO ======================  */
document.querySelectorAll('.case-study-intro').forEach(function (block) {
  var swiperEl = block.querySelector('.case-study-intro__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  new Swiper(swiperEl, {
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 600,
    breakpoints: {
      480: { slidesPerView: 1.5 },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: {
      init: function (swiper) {
        if (progressFill) progressFill.style.width = (swiper.progress * 100) + '%';
      },
      progress: function (swiper, progress) {
        if (progressFill) progressFill.style.width = (progress * 100) + '%';
      },
    },
  });
});

/* Swiper: hide .swiper-ui when all slides fit (no scrolling). */
function setSwiperUiVisibility(swiper) {
  if (!swiper) return;
  var block = swiper.el && swiper.el.closest && swiper.el.closest('.video-slider, .related-work');
  if (!block) return;
  var ui = block.querySelector('.swiper-ui');
  if (!ui) return;
  if (swiper.isLocked) {
    ui.setAttribute('hidden', '');
  } else {
    ui.removeAttribute('hidden');
  }
}

function getVideoLikeSliderOn(progressFill) {
  return {
    init: function (swiper) {
      if (progressFill) progressFill.style.width = (swiper.progress * 100) + '%';
      setSwiperUiVisibility(swiper);
    },
    progress: function (swiper, progress) {
      if (progressFill) progressFill.style.width = (progress * 100) + '%';
    },
    resize: function (swiper) {
      setSwiperUiVisibility(swiper);
    },
    lock: function (swiper) {
      setSwiperUiVisibility(swiper);
    },
    unlock: function (swiper) {
      setSwiperUiVisibility(swiper);
    },
    update: function (swiper) {
      setSwiperUiVisibility(swiper);
    },
  };
}

/* ====================== VIDEO SLIDER ======================  */
document.querySelectorAll('.video-slider').forEach(function (block) {
  var swiperEl = block.querySelector('.video-slider__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  new Swiper(swiperEl, {
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 600,
    watchOverflow: true,
    breakpoints: {
      480: { slidesPerView: 1.5 },
      768: { slidesPerView: 2.5, spaceBetween: 24 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1200: { slidesPerView: 3, spaceBetween: 24 },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: getVideoLikeSliderOn(progressFill),
  });
});

/* ====================== RELATED WORK (same slide layout as video slider) ======================  */
document.querySelectorAll('.related-work').forEach(function (block) {
  var swiperEl = block.querySelector('.related-work__swiper');
  var wrapper = block.querySelector('.swiper-wrapper');
  if (!swiperEl || !wrapper || !wrapper.children.length) return;

  var nextEl = block.querySelector('.swiper-ui__btn--next');
  var prevEl = block.querySelector('.swiper-ui__btn--prev');
  var progressFill = block.querySelector('.swiper-ui__progress-fill');

  new Swiper(swiperEl, {
    slidesPerView: 1.1,
    spaceBetween: 20,
    speed: 600,
    watchOverflow: true,
    breakpoints: {
      480: { slidesPerView: 1.5 },
      768: { slidesPerView: 2.5, spaceBetween: 24 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1200: { slidesPerView: 3, spaceBetween: 24 },
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    on: getVideoLikeSliderOn(progressFill),
  });
});

/* ====================== VIDEO SLIDER LIGHTBOX ======================  */
function videoSliderIframeAutoplaySrc(src) {
  if (!src) return src;
  try {
    var u = new URL(src, window.location.href);
    var host = u.hostname.replace(/^www\./, '').toLowerCase();
    if (host === 'player.vimeo.com') {
      u.searchParams.set('autoplay', '1');
      return u.toString();
    }
    if (host.indexOf('youtube.com') !== -1 || host.indexOf('youtube-nocookie.com') !== -1) {
      if (u.pathname.indexOf('/embed/') !== -1) {
        u.searchParams.set('autoplay', '1');
        return u.toString();
      }
    }
  } catch (e) {}
  return src;
}

function videoSliderApplyEmbedAutoplay(root) {
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll('iframe[src]').forEach(function (iframe) {
    var next = videoSliderIframeAutoplaySrc(iframe.getAttribute('src'));
    if (next && next !== iframe.getAttribute('src')) {
      iframe.setAttribute('src', next);
    }
  });
}

function animateVideoLightboxOpen(lightbox) {
  var backdrop = lightbox.querySelector('.video-slider__lightbox-backdrop');
  var inner = lightbox.querySelector('.video-slider__lightbox-inner');
  if (!backdrop || !inner) return;

  lightbox.removeAttribute('hidden');
  document.body.style.overflow = 'hidden';

  gsap.set(backdrop, { opacity: 0 });
  gsap.set(inner, { scale: 0.94, opacity: 0 });

  gsap.timeline({ overwrite: true })
    .to(backdrop, { opacity: 1, duration: 0.35, ease: 'power2.out' })
    .to(inner, { scale: 1, opacity: 1, duration: 0.45, ease: 'back.out(1.15)' }, '-=0.2');
}

function animateVideoLightboxClose(lightbox, onComplete) {
  var backdrop = lightbox.querySelector('.video-slider__lightbox-backdrop');
  var inner = lightbox.querySelector('.video-slider__lightbox-inner');
  if (!backdrop || !inner) {
    if (onComplete) onComplete();
    return;
  }

  gsap.timeline({ overwrite: true })
    .to(inner, { scale: 0.94, opacity: 0, duration: 0.2, ease: 'power2.in' })
    .to(backdrop, { opacity: 0, duration: 0.25, ease: 'power2.out' }, '-=0.1')
    .eventCallback('onComplete', function () {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (onComplete) onComplete();
    });
}

function closeVideoLightboxAndCleanup(lightbox) {
  if (!lightbox) return;
  if (lightbox.hidden) {
    document.body.style.overflow = '';
    return;
  }
  animateVideoLightboxClose(lightbox, function () {
    var content = lightbox.querySelector('.video-slider__lightbox-content');
    if (content) {
      var video = content.querySelector('video');
      if (video) video.pause();
      content.innerHTML = '';
    }
  });
}

document.querySelectorAll('.js-video-slider-open').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var block = btn.closest('.video-slider');
    if (!block) return;
    var lightbox = block.querySelector('.js-video-slider-lightbox');
    var content = block.querySelector('.video-slider__lightbox-content');
    if (!lightbox || !content) return;

    var type = btn.getAttribute('data-video-type');
    var mp4 = btn.getAttribute('data-video-mp4') || '';

    content.innerHTML = '';

    if (type === 'mp4' && mp4) {
      var video = document.createElement('video');
      video.src = mp4;
      video.controls = true;
      video.autoplay = true;
      video.setAttribute('playsinline', '');
      content.appendChild(video);
      video.play().catch(function () {});
    } else if (type === 'embed') {
      var slide = btn.closest('.video-slider__slide');
      var template = slide ? slide.querySelector('.js-video-slider-embed') : null;
      var embedHtml = template ? template.textContent.trim() : '';
      if (embedHtml) {
        var wrap = document.createElement('div');
        wrap.className = 'video-slider__embed-wrap';
        wrap.innerHTML = embedHtml;
        videoSliderApplyEmbedAutoplay(wrap);
        content.appendChild(wrap);
      }
    }

    animateVideoLightboxOpen(lightbox);
  });
});

document.querySelectorAll('.js-video-slider-lightbox-close').forEach(function (el) {
  el.addEventListener('click', function () {
    var lightbox = document.querySelector('.js-video-slider-lightbox:not([hidden])');
    closeVideoLightboxAndCleanup(lightbox);
  });
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var lightbox = document.querySelector('.js-video-slider-lightbox:not([hidden])');
  closeVideoLightboxAndCleanup(lightbox);
});
